import { StyleSheet } from 'react-native';
import { utils } from '@ltfe/ltfe-core-lib';
const { deviceWidth, deviceHeight, pt, px } = utils;

export default StyleSheet.create({
    container: {
        position: 'absolute',
        width: deviceWidth,
        height: deviceHeight,
        zIndex: 100,
        elevation: 2000
    },
    modalContainer: {
        position: 'absolute',
        zIndex: 101
    },
    mask: {
        position: 'fixed',
        width: deviceWidth,
        height: deviceHeight,
        zIndex: 102,
        left: 0,
        top: 0,
        overflow: "hidden",
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    innerContainer: {
        zIndex: 104,
        maxHeight: pt(500),
        backgroundColor: '#fff',
        borderTopLeftRadius: pt(12),
        borderTopRightRadius: pt(12),
        borderBottomLeftRadius: pt(12),
        borderBottomRightRadius: pt(12)
    },
    dialogInner: {
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: 103,
        backgroundColor: '#ffffff',
        borderRadius: 10
    },
    content_color: {
        color: '#2E2D2D'
    },
    title: {
        fontSize: pt(16),
        paddingBottom: pt(7),
        fontWeight: '600'
    },
    main: {
        paddingLeft: pt(20),
        paddingRight: pt(20),
        paddingBottom: pt(20),
        textAlign: 'center',
        fontSize: pt(14),
        lineHeight: pt(20)
    },
    content: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: pt(25)
    },
    btn_group: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: pt(18)
    },
    btn: {
        justifyContent: 'center',
        alignItems: 'center',
        width: pt(112),
        height: pt(31),
        marginHorizontal: pt(10)
    },
    cancel_btn: {
        textAlign: 'center',
        paddingVertical: pt(9.5),

        borderWidth: px(2),
        borderRadius: pt(17),
        borderColor: '#F2270C'
    },
    cancel_text: {
        fontSize: pt(12),
        height: pt(31),
        lineHeight: pt(31),
        color: '#F2270C'
    },
    wrap: {
        width: pt(112),
        borderRadius: pt(17),
        overflow: 'hidden'
    },
    single: {
        width: pt(145)
    },
    sure_text: {
        fontSize: pt(12),
        color: '#fff'
    }
});
